import type { RootState } from "@/store/app/storeTypes";

export const profileFromState = (
  state: RootState,
): {
  organisation: string | undefined;
  currentFinancialInstitution: string | undefined;
} => {
  const p = state.user?.userProfile;
  return {
    organisation: p?.organisation,
    currentFinancialInstitution: p?.currentFinancialInstitution,
  };
};
